export default __webpack_public_path__ + "static/media/human_capital.3ded25fd.jpeg";